// extracted by mini-css-extract-plugin
export default {"companyContainer":"company_companyContainer__YMpp8","titleHead":"company_titleHead__9B3vo"};